import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="SHOUTENGAI no ana Zuma Tachi parte 2"
      portada="https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-1.jpg"
     paginas={[
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-1.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-2.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-3.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-4.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-5.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-6.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-7.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-8.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-9.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-10.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-11.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-12.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-13.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-14.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-15.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-16.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-17.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-18.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-19.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-20.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-21.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-22.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-23.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-24.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-25.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-26.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-27.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-28.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-29.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-30.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-31.jpg",
  "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-32.jpg"
]}

      
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
        tipo: "doujinshi",
        idioma: "Español",
        serie: "Original",
        personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blowjob", "Blowjob Face", "Cheating", "Digital", "Hidden Sex", "Huge Breasts", "Kissing", "Milf", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Sole Male", "Sweating", "Uncensored", "Voyeurism"],    
    artistas: "fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "SHOUTENGAI no ana Zuma Tachi parte 2",
  portada: "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-1.jpg",
  reverso: "https://fullcomics18.org/img7/shoutengai-no-ana-zuma-tachi2-32.jpg",
      fecha:"2026-05-9", // 👈 MOVER AQUÍ

  info: {
  grupo: "shoot the moon",
        tipo: "doujinshi",
        idioma: "Español",
        serie: "Original",
        personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blowjob", "Blowjob Face", "Cheating", "Digital", "Hidden Sex", "Huge Breasts", "Kissing", "Milf", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Sole Male", "Sweating", "Uncensored", "Voyeurism"],       
artistas: "fuetakishi",

  },
};
